var map = {
	"./android.jpg": 70601,
	"./bird 1.jpg": 77746,
	"./flowers.jpg": 32004,
	"./fox.jpg": 20119,
	"./rabbit 02.jpg": 33758,
	"./rabbit 3.jpg": 21121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45736;